module.exports = __webpack_public_path__ + "img/SE5164019746.1f337ae4.png";